'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';
import parse from 'html-react-parser';
import { MenuItemType } from '@overlapdev/types';
import { SvgImage } from '@overlapdev/elements';
import { ArrowLeftSVG, ArrowRightSVG } from 'components/svg';

type MegaNavItemType = {
	current_id: number;
	item: MenuItemType;
	level: number;
	main_title: string;
	root_id: number;
	handleRoot: (offset: number | string, current_id: number) => void;
};

const MegaNavMobileItem = ({ item, level, main_title, root_id, current_id, handleRoot }: MegaNavItemType) => {
	//__Hooks
	const pathname = usePathname();

	//__Variables
	const { acf, child_items, classes, id, link, target, title } = item || {};
	const last_index_slash = pathname.lastIndexOf('/');
	const current_cat_path = pathname.substring(0, last_index_slash);

	const { add_icon_excerpt, icon_excerpt } = acf || {};
	const { excerpt, icon } = icon_excerpt || {};
	level++;

	//__Function
	const move = (level: number) => {
		handleRoot(`-${level * 100}%`, root_id);
	};

	return (
		<li key={`nav_item-${id}`} className={`${classes.toString().replace(/,/g, ' ')}${pathname === link || current_cat_path === link ? ' current' : ''}${child_items?.length ? ' mega_child_items' : ''}`} id={id?.toString() || ''}>
			<div className='h-full relative'>
				<Link className='flex gap-2' href={link || ''} as={link} passHref={target === '_blank' ? true : false} target={target}>
					<span className='shrink-0 w-6'>{add_icon_excerpt && icon?.url ? <SvgImage className='svg' image={icon} /> : null}</span>
					<span className='grow'>
						<span className='block font-semibold pr-8'>{parse(title || '')}</span>
						{add_icon_excerpt && excerpt ? <span className='excerpt'>{parse(excerpt)}</span> : null}
					</span>
				</Link>
				{child_items?.length ? (
					<span className='child_arrow' aria-label='toggle' onClick={() => move(level)}>
						<ArrowRightSVG className='ml-0.5 opacity-60' width={7} />
					</span>
				) : null}
			</div>
			{child_items?.length ? (
				<div className={`absolute top-0 left-full w-full ${current_id === root_id ? '' : 'hidden'}`}>
					<div className='px-8 py-6'>
						<div className='cursor-pointer flex gap-3 items-center mb-6 mt-1.5' onClick={() => move(level - 1)} role='button'>
							<span>
								<ArrowLeftSVG className='opacity-60' width={7} />
							</span>
							<span className='font-semibold text-xl'>Back</span>
						</div>
						<div className='font-medium text-grey text-xs'>{parse(title)}</div>
					</div>
					<ul className='h-[calc(95dvh-170px)] overflow-auto'>
						{child_items.map((child_item) => (
							<MegaNavMobileItem key={`mega_child_${child_item.id}`} item={child_item} level={level} main_title={main_title} current_id={current_id} root_id={root_id} handleRoot={handleRoot} />
						))}
					</ul>
				</div>
			) : null}
		</li>
	);
};

export default MegaNavMobileItem;
